import { types as STORE_MODULES } from '@/js/plugins/store/store-modules'
import ACTION_TYPES from '@/js/plugins/store/modules/aimeos/actions/actions-types'
import GETTER_TYPES from '@/js/plugins/store/modules/aimeos/getter-types'
import APP_ACTIONS from '@/js/plugins/store/modules/app/action-types.js'
import FILTER_CONSTANTS from '@/js/helper/filter-constants.js'

const getScopeFilter = async store => {
  console.log('🚀 ~ getScopeFilter ~ store GET_ALL_FILTER')
  await store.dispatch(`${STORE_MODULES.APP}/${APP_ACTIONS.GET_ALL_FILTER}`)
  console.log('🚀 ~ getScopeFilter ~ store GET_SCOPE_FILTER')
  store.dispatch(`${STORE_MODULES.APP}/${APP_ACTIONS.GET_SCOPE_FILTER}`, {
    scope: FILTER_CONSTANTS.SCOPE.BIKES,
  })
  store.dispatch(`${STORE_MODULES.APP}/${APP_ACTIONS.GET_SCOPE_FILTER}`, {
    scope: FILTER_CONSTANTS.SCOPE.SERVICE,
  })
  store.dispatch(`${STORE_MODULES.APP}/${APP_ACTIONS.GET_SCOPE_FILTER}`, {
    scope: FILTER_CONSTANTS.SCOPE.ACCESSORIES,
  })
  store.dispatch(`${STORE_MODULES.APP}/${APP_ACTIONS.GET_SCOPE_FILTER}`, {
    scope: FILTER_CONSTANTS.SCOPE.PART_SALE,
  })
  store.dispatch(`${STORE_MODULES.APP}/${APP_ACTIONS.GET_SCOPE_FILTER}`, {
    scope: FILTER_CONSTANTS.SCOPE.ARCHIVE,
  })
}

export default store => {
  const AIMEOS = STORE_MODULES.AIMEOS
  // ToDo: modify to use this pattern: const productResourceUrl = await getters[AIMEOS_GETTER_TYPES.PROMISE_OPTIONS_PRODUCT_URL]?
  store.watch(
    (state, getters) => getters[`${AIMEOS}/${GETTER_TYPES.OPTIONS_DATA}`],
    () => {
      store.dispatch(
        `${AIMEOS}/${ACTION_TYPES.SET_BASKET_URL}`,
        store.getters[`${AIMEOS}/${GETTER_TYPES.OPTIONS_BASKET_URL}`],
      )
      store.dispatch(
        `${AIMEOS}/${ACTION_TYPES.SET_CUSTOMER_URL}`,
        store.getters[`${AIMEOS}/${GETTER_TYPES.OPTIONS_CUSTOMER_URL}`],
      )
      store.dispatch(
        `${AIMEOS}/${ACTION_TYPES.SET_SERVICE_URL}`,
        store.getters[`${AIMEOS}/${GETTER_TYPES.OPTIONS_SERVICE_URL}`],
      )
      store.dispatch(
        `${AIMEOS}/${ACTION_TYPES.SET_ORDER_URL}`,
        store.getters[`${AIMEOS}/${GETTER_TYPES.OPTIONS_ORDER_URL}`],
      )
      store.dispatch(
        `${AIMEOS}/${ACTION_TYPES.SET_FAVORITE_URL}`,
        store.getters[`${AIMEOS}/${GETTER_TYPES.OPTIONS_FAVORITE_URL}`],
      )
      store.dispatch(
        `${AIMEOS}/${ACTION_TYPES.SET_COMPARE_URL}`,
        store.getters[`${AIMEOS}/${GETTER_TYPES.OPTIONS_COMPARE_URL}`],
      )

      getScopeFilter(store)
    },
  )
}
